import { Controller } from "@hotwired/stimulus"

// „Fylla út með gjaldskrá" overwrites the fixed part - dómaragjald and the
// three travel fields - so it asks first when there is something there to
// overwrite, and goes straight through when there is not. Filling in a blank
// form is the ordinary case and has nothing to warn about.
//
// Decided here rather than rendered on, because what the button would overwrite
// is whatever is in the boxes at the moment it is pressed. A ref who types an
// amount and then presses it has changed nothing the server has seen.
export default class extends Controller {
  static targets = [ "fixed", "button" ]
  static values = { warning: String }

  connect() {
    this.syncWarning()
  }

  // Only the fixed part: the optional amounts are put there by their own ticks
  // and the gjaldskrá writes back the same numbers, so warning about them would
  // be warning about nothing. Part 3 it never touches at all.
  syncWarning() {
    // A registration nobody can edit has no button to hang this on.
    if (!this.hasButtonTarget) return

    const filled = this.fixedTargets.some((field) => field.value.trim() !== "")

    if (filled) {
      this.buttonTarget.setAttribute("data-turbo-confirm", this.warningValue)
    } else {
      this.buttonTarget.removeAttribute("data-turbo-confirm")
    }
  }
}
